import React from "react";

const Welcome = () => {
  return (
    <div className="my-3">
      <div className="container-fluid">
        <div className="d-flex justify-content-center align-items-center">
          <div
            style={{
              width: "100%",
              maxWidth: "1200px",
              background: "#f8eef3",
              borderRadius: "30px",
              padding: "60px 40px",
              boxShadow: "0 15px 40px rgba(133, 46, 89, 0.12)",
              border: "1px solid rgba(133, 46, 89, 0.08)",
            }}
          >
            {/* Header Section */}
            <div className="text-center">
              <div
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #852e59 0%, #b84f82 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 25px",
                  color: "#fff",
                  fontSize: "55px",
                  boxShadow: "0 15px 35px rgba(133,46,89,0.25)",
                }}
              >
                📹
              </div>

              <h1
                style={{
                  fontSize: "2rem",
                  fontWeight: "400",
                  color: "#852e59",
                  marginBottom: "15px",
                }}
              >
                Welcome to KNF Security Hub
              </h1>

              <p
                style={{
                  maxWidth: "750px",
                  margin: "0 auto",
                  fontSize: "18px",
                  color: "#6b7280",
                  lineHeight: "1.8",
                }}
              >
                Monitor security cameras, receive weather warnings, and stay
                informed with real-time alerts. KNF Security Hub provides
                intelligent monitoring solutions to help protect your locations,
                assets, and people 24/7.
              </p>
            </div>

            {/* Feature Cards */}
            <div className="row mt-1 g-4">
              <div className="col-lg-4 col-md-6">
                <div
                  style={{
                    background: "#ffffff",
                    borderRadius: "20px",
                    padding: "30px",
                    height: "100%",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                    transition: "0.3s",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "15px",
                      background: "#f8eef3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "35px",
                      marginBottom: "20px",
                    }}
                  >
                    📹
                  </div>

                  <h4
                    style={{
                      color: "#852e59",
                      fontWeight: "600",
                    }}
                  >
                    Camera Monitoring
                  </h4>

                  <p
                    style={{
                      color: "#6b7280",
                      marginBottom: 0,
                    }}
                  >
                    View live camera feeds, monitor activities, and receive
                    instant notifications whenever suspicious events are
                    detected.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div
                  style={{
                    background: "#ffffff",
                    borderRadius: "20px",
                    padding: "30px",
                    height: "100%",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "15px",
                      background: "#f8eef3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "35px",
                      marginBottom: "20px",
                    }}
                  >
                    🌦️
                  </div>

                  <h4
                    style={{
                      color: "#852e59",
                      fontWeight: "600",
                    }}
                  >
                    Weather Alerts
                  </h4>

                  <p
                    style={{
                      color: "#6b7280",
                      marginBottom: 0,
                    }}
                  >
                    Stay prepared with real-time weather notifications including
                    heavy rain, storms, floods, and other environmental threats.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div
                  style={{
                    background: "#ffffff",
                    borderRadius: "20px",
                    padding: "30px",
                    height: "100%",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "15px",
                      background: "#f8eef3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "35px",
                      marginBottom: "20px",
                    }}
                  >
                    🔔
                  </div>

                  <h4
                    style={{
                      color: "#852e59",
                      fontWeight: "600",
                    }}
                  >
                    Smart Notifications
                  </h4>

                  <p
                    style={{
                      color: "#6b7280",
                      marginBottom: 0,
                    }}
                  >
                    Receive instant security and weather alerts through a
                    centralized notification system designed for rapid response.
                  </p>
                </div>
              </div>
            </div>

            {/* Statistics */}
            <div className="row mt-1 g-4">
              <div className="col-md-3 col-6">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "25px",
                    borderRadius: "18px",
                    textAlign: "center",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <h2
                    style={{
                      color: "#852e59",
                      fontWeight: "700",
                    }}
                  >
                    24/7
                  </h2>
                  <p className="mb-0 text-secondary">Monitoring</p>
                </div>
              </div>

              <div className="col-md-3 col-6">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "25px",
                    borderRadius: "18px",
                    textAlign: "center",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <h2
                    style={{
                      color: "#852e59",
                      fontWeight: "700",
                    }}
                  >
                    Live
                  </h2>
                  <p className="mb-0 text-secondary">Camera Feed</p>
                </div>
              </div>

              <div className="col-md-3 col-6">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "25px",
                    borderRadius: "18px",
                    textAlign: "center",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <h2
                    style={{
                      color: "#852e59",
                      fontWeight: "700",
                    }}
                  >
                    Instant
                  </h2>
                  <p className="mb-0 text-secondary">Alerts</p>
                </div>
              </div>

              <div className="col-md-3 col-6">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "25px",
                    borderRadius: "18px",
                    textAlign: "center",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <h2
                    style={{
                      color: "#852e59",
                      fontWeight: "700",
                    }}
                  >
                    Secure
                  </h2>
                  <p className="mb-0 text-secondary">Protection</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
